import React from "react";
import { PaymentElement } from "@stripe/react-stripe-js";

interface Props {
  onHasLoaded: () => void
  hasLoaded: boolean
}

const StripeSetupIntentForm = (props: Props) => {
  const onHasLoaded = () => {
    props.onHasLoaded();
  };

  const styles = props.hasLoaded ? undefined : { display: "none" };

  return (
    <div
      style={styles}
    >
      <PaymentElement
        onReady={onHasLoaded}
      />
    </div>
  );
};

export default StripeSetupIntentForm;